import { render, staticRenderFns } from "./ReactionAnimated2Icon.vue?vue&type=template&id=425ef114&scoped=true"
import script from "./ReactionAnimated2Icon.vue?vue&type=script&lang=js"
export * from "./ReactionAnimated2Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425ef114",
  null
  
)

export default component.exports